import { staffAttendance } from "../client";


export const reportchart = (params) => {
  console.log(params,"params")
  const user = {
    flag: "getReport",
    parameters: {
      reportForAdmin: {
        fromYear: parseInt(params.from),
        toYear: parseInt(params.to),
        institutionId:(params.institutionId)
      },
    },
  };
  return staffAttendance.post("/report/admin/student", user);
};
